var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopLeftBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 8C1.25 3.85786 4.60786 0.5 8.75 0.5H24.25V23.5H1.25V8Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 8C1.25 3.85786 4.60786 0.5 8.75 0.5H24.25V23.5H1.25V8Z",
    stroke: "#939393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0303 5.28079C6.24537 5.06571 6.51364 5.00536 6.76724 4.99244C7.0017 4.98048 7.29301 5.007 7.62082 5.03683L8.41087 5.10865C8.96699 5.15918 9.43295 5.20152 9.77461 5.2833C10.1164 5.3651 10.4965 5.52317 10.6451 5.9336C10.7937 6.34402 10.6029 6.70877 10.3927 6.99043C10.1929 7.25811 9.88404 7.57031 9.51479 7.93971L13.5896 12.0145C13.8173 12.2423 13.8173 12.6116 13.5896 12.8394C13.3618 13.0672 12.9924 13.0672 12.7646 12.8394L8.68984 8.76466C8.32019 9.13414 8.00778 9.44331 7.73994 9.64316C7.45828 9.85339 7.09353 10.0442 6.68311 9.89557C6.27268 9.74699 6.11461 9.36689 6.03281 9.02512C5.95103 8.6834 5.90869 8.21743 5.85816 7.66138L5.78634 6.8713C5.75651 6.54349 5.73 6.25218 5.74195 6.01773C5.75487 5.76413 5.81523 5.49586 6.0303 5.28079Z",
    fill: "#141B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLeftBorder);
export default __webpack_public_path__ + "static/media/TopLeftBorder.2d5875642d7b043b22089fbcb04d75bb.svg";
export { ForwardRef as ReactComponent };